import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import axiosInstance from "../../../../../redux/api";
import SkillSelector from "../../../../Common/SkillSelector";

export default function CSelectSkills({ formData, setFormData, nextPage, previousPage }) {
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState(false);
  const [allSkills, setAllSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState(formData.skills || []);

  useEffect(() => {
    if (formData?.category_id) {
      axiosInstance
        .get(`category?type=6&category_id=${formData?.category_id}`)
        .then((res) => {
          if (res?.data) {
            setAllSkills(res.data?.response || []);
          }
        })
        .catch((err) => console.error("Error fetching skills:", err));
    }
  }, [formData?.category_id]);

  const SubmitandNext = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (selectedSkills.length > 2) {
      nextPage();
      setValidation(false);
    } else {
      setValidation(true);
    }
    setLoading(false);
  };

  return (
    <div className="app-container">
      <div className="col-lg-10 col-md-11 mx-auto expert-flow">
        <div className="col-lg-10 mx-auto">
          <div className="row about-row">
            <div className="col-md-5 about-left">
              <h6>
                02/03 <span>Required competencies</span>
              </h6>
              <h2>Add Required competencies for this contest</h2>
              <p>Choose or search competencies required</p>
            </div>
            <div className="col-lg-6 about-right skill-sec-button">
              <h6>Search or add competencies</h6>

              <SkillSelector
                allSkills={allSkills}
                selectedSkills={selectedSkills}
                setSelectedSkills={setSelectedSkills}
                setFormData={setFormData}
                validation={validation}
                setValidation={setValidation}
              />

              <div className="popular-skill">
                <h5>Popular competencies based on your designation</h5>
                <div className="add-skills">
                  {allSkills
                    .filter((skill) => !selectedSkills.some((s) => s.id == skill.id))
                    .map((skill, index) => (
                      <div key={index}>
                        <p
                          className="select-deactive-skill"
                          onClick={() => {
                            const newSkill = { id: skill.id, title: skill.title };
                            const updatedSkills = [...selectedSkills, newSkill];
                            setSelectedSkills(updatedSkills);
                            setFormData((prev) => ({
                              ...prev,
                              skills: updatedSkills,
                            }));
                          }}
                        >
                          {skill.title} <span>+</span>
                        </p>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container col-lg-8 col-md-11 mx-auto">
        <button disabled={loading} type="button" onClick={previousPage} className="prev-button">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>
        <button type="button" onClick={SubmitandNext} className="next-button">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
}
